const IgnoredKeys = [
    "Alt",
    "Control",
    "Meta",
    "Shift",
    "ArrowUp",
    "ArrowRight",
    "ArrowDown",
    "ArrowLeft",
    "CapsLock",
    "Escape",
    "Enter",
    "Tab",
    "Home",
    "End",
    "PageUp",
    "PageDown",
    "NumLock",
    "Insert",
];
export function isIgnoredKey(key) {
    return IgnoredKeys.includes(key);
}
